module.exports = __webpack_public_path__ + "static/logo-d5561d5024a2cd840f908db995120692.svg";